/**
 * 图片 fileId 列表工具（逗号串 / JSON 数组等存法）
 */

/** fileId 列表去重（保序） */
export function uniqueFileIds (ids) {
  if (!ids || !ids.length) return [];
  const seen = new Set();
  const out = [];
  for (let i = 0; i < ids.length; i++) {
    const id = ids[i];
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}

/**
 * 将接口或表单中的「图片 id 字段」解析为 fileId 数组
 * 支持：数组、逗号分隔、JSON 数组字符串
 */
export function parseImageFileIds (val) {
  if (val == null || val === '') return [];
  if (Array.isArray(val)) return val.map(x => (x != null ? String(x).trim() : '')).filter(Boolean);
  const s = String(val).trim();
  if (!s) return [];
  if (s.startsWith('[')) {
    try {
      const arr = JSON.parse(s);
      return Array.isArray(arr) ? arr.map(x => String(x).trim()).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }
  return s.split(',').map(x => x.trim()).filter(Boolean);
}
